<template>
 <div class="main">
   <Top />
    <div class="center">
      <router-view />
      <div class="footer">
        <Bottom />
      </div>
    </div>
 </div>
</template>

<script>
import Top from '../components/Top.vue'
import Bottom from '../components/Bottom.vue'
// import Layout from '../components/Layout.vue'

export default {
  data() {
    return {

    }
  },
  components: {
    Top,
    Bottom
    // Layout
  }
}
</script>

<style lang="scss" scoped>
html,body {
  height: 100%;
  width: 100%;
  background: #F8FAF8
}
.main {
  // height: 100vh;
  // width: 100%;
  .center {
    height: 100%;
    width: 100%;
    overflow-y: hidden;
    background: #0C1364;
    .footer {
      // position: absolute;
      // bottom: 0;
      width: 100%;
    }
  }
}

</style>
